import { render } from "./add_room_Drawer.vue?vue&type=template&id=510c758e&ts=true"
import script from "./add_room_Drawer.vue?vue&type=script&lang=ts"
export * from "./add_room_Drawer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__